import script from "./FixmePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./FixmePanel.vue?vue&type=script&setup=true&lang=js"

import "./FixmePanel.vue?vue&type=style&index=0&id=610971b5&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-610971b5"]])

export default __exports__